interface CatalogSkeletonProps {
  count?: number;
  showTitle?: boolean;
}

export function CatalogSkeleton({
  count = 2,
  showTitle = true,
}: CatalogSkeletonProps) {
  return (
    <div className="py-8">
      {/* Título de la sección skeleton */}
      {showTitle && (
        <div className="mb-6">
          <div className="h-8 md:h-10 bg-gray-200 rounded-lg w-48 md:w-64 animate-pulse" />
          <div className="h-4 bg-gray-200 rounded w-32 md:w-40 mt-2 animate-pulse" />
        </div>
      )}

      {/* Grid de catálogos skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="relative bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden h-48"
          >
            {/* Imagen del catálogo skeleton (fondo) */}
            <div className="absolute inset-0 bg-gradient-to-br from-gray-300 via-gray-400 to-gray-500 animate-pulse" />

            {/* Overlay oscuro semi-transparente */}
            <div className="absolute inset-0 bg-black/30"></div>

            {/* Contenido centrado */}
            <div className="relative z-10 h-full flex flex-col justify-between p-6">
              {/* Título centrado */}
              <div className="flex-1 flex items-center justify-center">
                <div className="h-6 md:h-8 bg-white/40 rounded w-32 md:w-40 animate-pulse" />
              </div>

              {/* CTA en la esquina inferior derecha */}
              <div className="flex justify-end">
                <div className="h-4 bg-white/40 rounded w-24 animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
